'use strict';

module.exports = function trucateSentence(val, maxLength) {
	if (!maxLength || maxLength < 0) {
		return val;
	}
	const words = (val && val.length && val.split(' ')) || [],
		included = [];
	let length = 0, result = false;

	while ((included.length < words.length) && (length + words[included.length].length) < maxLength) {
		length += words[included.length].length + 1;
		included.push(words[included.length]);
	}
	result = included.join(' ');
	if (included.length < words.length) {
		return result + '...';
	}
	return result;
};
